/**
 * Samouczek 'Sprzedaz - paragon z NIP'. Ksztalt danych: patrz frontend/src/pomoc/samouczki/KONTRAKT.md
 *
 * Opis odpowiada temu, co kasa NAPRAWDE robi (sprawdzone na test.v3system.pl, wrzesien 2026):
 *  - typ dokumentu to lista rozwijana "Dokument" w lewym gornym kafelku kasy (opcja "Paragon NIP"),
 *  - kasa wymaga klienta z NIP-em i blokuje sprzedaz powyzej 450 zl brutto (hooks/usePaymentProcessing.js),
 *  - sume kontrolna NIP-u sprawdza wylacznie przycisk "GUS" w oknie klienta; sam zapis karty
 *    i finalizacja pilnuja tylko tego, ze NIP ma 10 cyfr,
 *  - NIP trafia na paragon fiskalny (Web Serial, nip_nabywcy) i jest zapisany przy transakcji;
 *    lista "Paragony", okno "Szczegoly" i kopia PDF NIP-u nie pokazuja.
 */
const OBRAZ = (plik, opis) => ({ plik, opis });

const DZIALY = {
  A: { tytul: 'Klient z NIP-em', opis: 'Paragon z NIP zaczyna się od klienta, nie od towaru. Najpierw ustaw typ dokumentu i przypnij firmę do paragonu.' },
  B: { tytul: 'Nowa firma w kartotece', opis: 'Gdy klient jest u nas pierwszy raz: zakładasz kartę z NIP-em, a dane firmy pobierasz z GUS.' },
  C: { tytul: 'Sprzedaż i limit 450 zł', opis: 'Koszyk i płatność wyglądają jak zwykle. Jedyna różnica: kasa pilnuje kwoty.' },
  D: { tytul: 'Po sprzedaży', opis: 'Gdzie jest NIP, a gdzie go nie zobaczysz. Kiedy zamiast paragonu z NIP klient dostaje fakturę.' },
};

const PARAGON_NIP = {
  id: 'paragon-nip',
  dzialy: DZIALY,
  tytul: 'Sprzedaż — paragon z NIP',
  dlaKogo: 'Kasjerzy',
  czas: '4 minuty',
  pdf: '/instrukcje/paragon-nip.pdf',
  wstep: 'Klient prosi o paragon „na firmę"? To paragon z NIP nabywcy: zwykły paragon fiskalny, na którym '
    + 'drukarka dopisuje NIP firmy klienta. Kasa wystawi go tylko wtedy, gdy przypniesz do paragonu klienta '
    + 'z NIP-em i gdy kwota nie przekracza 450 zł brutto. Poniżej cała droga: od wyboru typu dokumentu do '
    + 'potwierdzenia sprzedaży.',
  kroki: [
    {
      n: 1,
      dzial: 'A',
      tytul: 'Ustaw „Dokument" na „Paragon NIP"',
      tresc: 'W lewym górnym kafelku kasy jest pole „Dokument" — normalnie stoi na „Paragon". '
        + 'Rozwiń je i wybierz „Paragon NIP". Ramka pola zrobi się pomarańczowa. '
        + 'Zrób to PRZED skanowaniem towaru: po zakończonej sprzedaży pole samo wraca na „Paragon", '
        + 'a klient zostaje odpięty.',
      obraz: OBRAZ('/instrukcje/paragon-nip-1-dokument.jpg', 'Rozwinięte pole Dokument z opcją Paragon NIP'),
    },
    {
      n: 2,
      dzial: 'A',
      tytul: 'Wybierz firmę z kartoteki',
      tresc: 'Przy nagłówku koszyka jest pole „Wyszukaj lub wybierz...". Wpisz nazwę firmy — po dwóch '
        + 'literach pod polem pojawia się lista podpowiedzi. Kliknij właściwą firmę. Na liście nie ma NIP-u, '
        + 'więc jeśli firm o podobnej nazwie jest kilka, dopytaj klienta o miasto albo sprawdź NIP w kroku 3. '
        + 'Nie ma firmy? Przejdź do kroku 4.',
      obraz: OBRAZ('/instrukcje/paragon-nip-2-klient.jpg', 'Pole klienta z listą podpowiedzi'),
    },
    {
      n: 3,
      dzial: 'A',
      tytul: 'Sprawdź NIP przyciskiem „Edytuj"',
      tresc: 'Wybrana firma pokazuje się na zielono przy koszyku, obok są przyciski „Historia" i „Edytuj". '
        + 'Kasa nie pokazuje tu NIP-u — kliknij „Edytuj" i przewiń okno do pola „NIP". Porównaj numer '
        + 'z tym, który podał klient. Jeśli pole jest puste, wpisz NIP i kliknij „Zapisz" na dole okna; '
        + 'bez NIP-u kasa zatrzyma sprzedaż komunikatem „Dla paragonu z NIP klient musi miec NIP! Edytuj klienta i dodaj NIP." '
        + 'Gdy wszystko się zgadza, zamknij okno przyciskiem „Anuluj".',
      obraz: OBRAZ('/instrukcje/paragon-nip-3-edytuj-nip.jpg', 'Okno Edytuj klienta z polem NIP'),
    },
    {
      n: 4,
      dzial: 'B',
      tytul: 'Załóż nową firmę: „+", „Firma", NIP, „GUS"',
      tresc: 'Kliknij zielony „+" obok pola klienta — otworzy się okno „Nowy klient". Najpierw kliknij '
        + '„Firma" (bez tego pole NIP w ogóle się nie pokazuje). Wpisz NIP: 10 cyfr, bez kresek i spacji. '
        + 'Kliknij „GUS" — nazwa firmy, REGON, adres i kod pocztowy wpiszą się same, a pod polem pojawi się '
        + 'zielony pasek „Czynny podatnik VAT". Sprawdź nazwę z klientem i kliknij „Dodaj" na dole okna. '
        + 'Firma od razu zostaje przypięta do paragonu. Jeśli kasa odpowie „Kontrahent o tym NIP już istnieje", '
        + 'firma jest w kartotece — użyj wskazanej karty zamiast zakładać nową.',
      obraz: OBRAZ('/instrukcje/paragon-nip-4-nowy-gus.jpg', 'Okno Nowy klient po pobraniu danych z GUS'),
    },
    {
      n: 5,
      dzial: 'B',
      tytul: 'Zły NIP — co mówi kasa',
      tresc: 'Za mało cyfr: przy próbie zapisu pod polem pojawia się „NIP musi mieć 10 cyfr" i karta się nie '
        + 'zapisze. Dziesięć cyfr, ale przekręcony numer: po kliknięciu „GUS" zobaczysz „Nieprawidłowy numer NIP". '
        + 'UWAGA: to jedyna kontrola. Jeśli pominiesz „GUS", kasa zapisze kartę z błędnym dziesięciocyfrowym '
        + 'NIP-em i wystawi na niego paragon — dlatego zawsze klikaj „GUS" przy nowej firmie.',
      obraz: OBRAZ('/instrukcje/paragon-nip-5-zly-nip.jpg', 'Komunikat GUS o nieprawidłowym numerze NIP'),
    },
    {
      n: 6,
      dzial: 'C',
      tytul: 'Nabij towar i pilnuj kwoty 450 zł',
      tresc: 'Koszyk działa jak przy zwykłym paragonie: skanujesz kod albo wpisujesz nazwę w polu '
        + '„Nazwa produktu lub kod kreskowy...", plusem i minusem zmieniasz ilość (szczegóły w samouczku '
        + '„paragon"). Różnica jest jedna: paragon z NIP może mieć najwyżej 450 zł brutto — równo 450 zł '
        + 'przechodzi, 450,01 zł już nie. Kasa sprawdza to przy kliknięciu „Zaplac" i zatrzymuje sprzedaż '
        + 'komunikatem „Kwota … zł przekroczyła 450 zł - nie możemy wystawić paragonu z NIP. Rozbij sprzedaż '
        + 'na dwa lub więcej paragonów…". Wtedy zrób tak, jak mówi komunikat: podziel zakupy na kilka '
        + 'paragonów z NIP, każdy do 450 zł.',
      obraz: OBRAZ('/instrukcje/paragon-nip-6-limit-450.jpg', 'Komunikat o przekroczeniu limitu 450 zł'),
    },
    {
      n: 7,
      dzial: 'C',
      tytul: 'Zapłać i sprawdź zielony komunikat',
      tresc: 'Kliknij „Dalej", potwierdź pytanie o aplikację („OK - Zapytalem"), wybierz formę płatności '
        + 'i kliknij „Zaplac". Przy gotówce wpisz, ile dał klient, i potwierdź drugim „Zaplac". Po chwili w prawym '
        + 'górnym rogu pojawia się zielony komunikat „Paragon z NIP nabywcy zostal pomyslnie zarejestrowany! NIP: ..." — '
        + 'z numerem firmy. Jeśli widzisz tylko zwykłe „Paragon zostal pomyslnie zarejestrowany!", paragon '
        + 'poszedł BEZ NIP-u. Czerwony komunikat o drukarce oznacza, że paragon nie wydrukował się fiskalnie — '
        + 'podłącz drukarkę i wydrukuj go z listy „Paragony".',
      obraz: OBRAZ('/instrukcje/paragon-nip-7-potwierdzenie.jpg', 'Zielone potwierdzenie z NIP-em nabywcy'),
    },
    {
      n: 8,
      dzial: 'D',
      tytul: 'Gdzie jest NIP po sprzedaży',
      tresc: 'NIP trafia na paragon fiskalny z drukarki i jest zapisany przy transakcji. Na kasie go nie '
        + 'zobaczysz: lista w zakładce „Paragony", okno „Szczegóły" ani kopia z „Drukuj paragon" nie pokazują '
        + 'NIP-u nabywcy. Dlatego jedynym Twoim potwierdzeniem jest zielony komunikat z kroku 7 i paragon '
        + 'z drukarki, który oddajesz klientowi. Sprawdź go, zanim klient odejdzie od kasy.',
      obraz: OBRAZ('/instrukcje/paragon-nip-8-paragony.jpg', 'Lista Paragony z paragonem z NIP'),
    },
    {
      n: 9,
      dzial: 'D',
      tytul: 'Paragon z NIP czy faktura?',
      tresc: 'Do 450 zł brutto: paragon z NIP — klient dostaje paragon i to jest jego dokument na firmę. '
        + 'Powyżej 450 zł kasa nie wystawi paragonu z NIP — rozbij sprzedaż na kilka paragonów z NIP albo, '
        + 'jeśli klient chce jeden dokument, w polu „Dokument" wybierz „Faktura firma" '
        + '(faktura VAT bez paragonu, też wymaga klienta z NIP-em). Jeśli tej opcji nie ma na liście, '
        + 'administrator wyłączył faktury firmowe na kasie — zapytaj kierownika. Opcja „Faktura im." to co innego: '
        + 'zwykły paragon plus faktura na dane osobowe, wystawiana później z listy paragonów do fakturowania.',
    },
  ],
  uwagi: [
    'Kolejność ma znaczenie: najpierw „Paragon NIP" i klient, potem towar. Po każdej sprzedaży pole „Dokument" wraca na „Paragon", a klient znika — dla drugiej firmy z rzędu ustawiasz wszystko od nowa.',
    'Bez klienta kasa zatrzyma „Zaplac" komunikatem „Dla paragonu z NIP musisz najpierw wybrac klienta!". Klient bez NIP-u — komunikatem „Dla paragonu z NIP klient musi miec NIP! Edytuj klienta i dodaj NIP.".',
    'Kasa nie sprawdza, czy NIP jest prawdziwy — sprawdza go tylko przycisk „GUS". Karta z błędnym dziesięciocyfrowym NIP-em zapisze się i paragon na nią wyjdzie. Klikaj „GUS" przy każdej nowej firmie.',
    'Limit 450 zł liczy się od kwoty po rabatach i pilnuje go także serwer — nie da się go obejść. '
      + 'Sprzedaż powyżej 450 zł dzielisz na kilka paragonów z NIP (każdy do 450 zł), a przy każdym '
      + 'ustawiasz „Paragon NIP" i klienta od nowa.',
    'Na kasie nie ma opcji dopisania NIP-u do zamkniętego paragonu (pod „..." są tylko „Szczegóły", „Drukuj paragon", „Fiskalizuj", „Zwrot" i „Płatność"). Jeśli paragon poszedł bez NIP-u, zgłoś to kierownikowi, zanim klient odejdzie.',
  ],
};

export default PARAGON_NIP;
